// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__A8WmF","messages":"Chat_messages__18hJL","dateDivider":"Chat_dateDivider__2kZPK"};